import { render, staticRenderFns } from "./duplicate.vue?vue&type=template&id=568cf689&scoped=true"
import script from "./duplicate.vue?vue&type=script&lang=js"
export * from "./duplicate.vue?vue&type=script&lang=js"
import style0 from "./duplicate.vue?vue&type=style&index=0&id=568cf689&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568cf689",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568cf689')) {
      api.createRecord('568cf689', component.options)
    } else {
      api.reload('568cf689', component.options)
    }
    module.hot.accept("./duplicate.vue?vue&type=template&id=568cf689&scoped=true", function () {
      api.rerender('568cf689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/practicalAssessment/duplicate.vue"
export default component.exports